var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('p',{staticClass:"copy_rights"},[_vm._v(" "+_vm._s(_vm.$t("TITLES.copyRightsVorma", { year: _vm.currentYear }))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }